import { PeopleRounded, PublicRounded, StarRounded } from '@mui/icons-material'
import { Typography, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'

const VisibilityBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    '& svg': {
      fontSize: 16,
      paddingRight: 2
    },
    '& p': {
      fontSize: 13,
      paddingLeft: 4,
      height: 15
    }
  },
  [theme.breakpoints.down('sm')]: {
    '& svg': {
      fontSize: 13,
      paddingRight: 4
    },
    '& p': {
      fontSize: 11,
      paddingLeft: 2
    }
  }
}))

const PrivateBox = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.grey[400],
  height: '100%'
}))

const Visibility = (props: any) => {
  const { type, variant } = props
  const { t } = useTranslation(['global'])

  const isDefault = variant != null
  const hideIcon = variant === 5
  return (
    <VisibilityBox>
      {type === 0 && (
        <PrivateBox>
          {!hideIcon && <PeopleRounded />} {isDefault ? '' : '|'} <Typography>{t('only-users')}</Typography>
        </PrivateBox>
      )}
      {type === 1 && (
        <PrivateBox>
          {!hideIcon && <StarRounded />} {isDefault ? '' : '|'}
          <Typography>VIP</Typography>
        </PrivateBox>
      )}
      {type === 2 && (
        <PrivateBox>
          {!hideIcon && <PublicRounded />} {isDefault ? '' : '|'}
          <Typography>{t('public')}</Typography>
        </PrivateBox>
      )}
    </VisibilityBox>
  )
}

export default Visibility
